let Translations = {
    en: {
        SessionTimeout: {
            title: 'Your Session is about to expire!',
            message: 'Your session is about to expire.',
            logoutButton: 'Logout',
            keepAliveButton: 'Stay Connected',
            sessionExpired: 'Your session might be expired.'
        },
        Rangepicker: {
            today: 'Today',
            thisMonth: 'This month',
            prevMonth: 'Previous month',
            thisYear: 'This year',
            prevYear: 'Previous year',
            clear: 'Clear'
        },
        Help: {
            text: 'Need help? Click here for more information'
        }
    },
    es: {
        SessionTimeout: {
            title: 'Tu sesión está a punto de expirar!',
            message: 'Tu sesión está a punto de expirar.',
            logoutButton: 'Cerrar sesión',
            keepAliveButton: 'Seguir conectado',
            sessionExpired: 'Puede que tu sesión haya expirado.'
        },
        Rangepicker: {
            today: 'Hoy',
            thisMonth: 'Este mes',
            prevMonth: 'El mes pasado',
            thisYear: 'Este año',
            prevYear: 'El año pasado',
            clear: 'Borrar'
        },
        Help: {
            text: '¿Necesitas ayuda? Más info.'
        }
    },
    et: {
        SessionTimeout: {
            title: 'Teie sessioon hakkab aeguma!',
            message: 'Teie sessioon hakkab aeguma.',
            logoutButton: 'Logi välja',
            keepAliveButton: 'Jätka sessiooni',
            sessionExpired: 'Teie sessioon võib olla aegunud.'
        },
        Rangepicker: {
            today: 'Täna',
            thisMonth: 'See kuu',
            prevMonth: 'Eelmine kuu',
            thisYear: 'See aasta',
            prevYear: 'Eelmine aasta',
            clear: 'Tühjenda'
        },
        Help: {
            text: 'Vajad abi? Vajuta siia, et saada rohkem infot.'
        }
    },
    it: {
        SessionTimeout: {
            title: 'La tua sessione sta per scadere!',
            message: 'La tua sessione sta per scadere',
            logoutButton: 'Logout',
            keepAliveButton: 'Rimani connesso',
            sessionExpired: 'La tua sessione potrebbe essere scaduta'
        },
        Rangepicker: {
            today: 'Oggi',
            thisMonth: 'Questo mese',
            prevMonth: 'Il mese scorso',
            thisYear: 'Quest\'anno',
            prevYear: 'L\'anno scorso',
            clear: 'Chiaro'
        },
        Help: {
            text: 'Hai bisogno di aiuto? Clicca qui'
        }
    },
    fr: {
        SessionTimeout: {
            title: 'Votre session est sur le point d\'expirer !',
            message: 'Votre session est sur le point d\'expirer.',
            logoutButton: 'Déconnexion',
            keepAliveButton: 'Rester connecté',
            sessionExpired: 'Votre session a expiré.'
        },
        Rangepicker: {
            today: 'Aujourd\'hui',
            thisMonth: 'Ce mois-ci',
            prevMonth: 'Mois précédent',
            thisYear: 'Cette année',
            prevYear: 'Année précédente',
            clear: 'Effacer'
        },
        Help: {
            text: 'Besoin d\'aide? Cliquez ici pour plus d\'informations'
        }
    }
};

export default Translations;
